import React, { useState } from "react";
import backicon from './../../../../../../Assets/icons/backIcon.svg'
import "./index.scss";
import { useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import ROUTES_NAVIGATION from "../../../../../../routes/routes";

const CustomerInputs = [
  {
    name: "name",
    label: "Taxset Name",
    type: "text",
    required: true,
   
    gridClass: "col-lg-4",
  },
  {
    name: "description",
    label: "Description",
    type: "text",
    required: true,
    
    gridClass: "col-lg-4",
  },
  {
    name: "status",
    label: "Status",
    type: "multiselectdropdown",
    required: true,
    options: [
        { label: "active", value: "Active" },
        { label: "inactive", value: "IN-Active" },
        
      ],
    gridClass: "col-lg-4",
  },
];


const AddTaxset = () => {
  const [formData, setFormData] = useState({});
 
const navigate=useNavigate()

  const handleFormSubmit = (data) => {
   
    console.log("Form Data:", data);
  
  };
 


  return (
    <>
      <div className="backbutton mt-2 mb-2">
        <img src={backicon} alt="back" onClick={()=>navigate(ROUTES_NAVIGATION.TAXSETLIST)} />
        <span className="backbtntitle">Add Taxset</span>
      </div>
      <div className="form-container">
        <span className="cust-det-title mt-2 mb-2">
          Please Enter Taxset Details
        </span>
        <DynamicForm
          formConfig={CustomerInputs}
          formData={formData}
          setFormData={setFormData}
          onSubmit={handleFormSubmit}
        />
       
        
      </div>
    
      <div className="btncontainer mt-3">
      <button
  onClick={() => {
   
      handleFormSubmit(formData); 
   
       
    
  }}
  className="submit-btn"
>
  Submit
</button>

        </div>
    </>
  );
};

export default AddTaxset;
